import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { getBarberByIdOrRoute } from '../barbers/selectors';
import WithTimezone from './WithTimezone';
import { getActiveTime, getActiveTimeBarber } from '../times/selectors';
import { parseTimeSlug, getAvailableTimesStartDay, getAvailableTimesEndDay } from '../utils/helpers';
import { reserveTime } from '../reservation/actions';
import { getServiceDuration } from '../services/selectors';
import WithFetchAvailability from './WithFetchAvailability';
import { clearBarberAvailability } from '../times/actions';
import WithAnyBarber from './WithAnyBarber';
import WithKioskProp from './WithKioskProp';

export default compose(
  WithTimezone,
  withRouter,
  WithFetchAvailability,
  WithAnyBarber,
  WithKioskProp,
  connect(
    (state, ownProps) => {
      let barberRoute = ownProps.params.barberRoute;
      if (ownProps.anyBarber) {
        barberRoute = getActiveTimeBarber(state);
      }

      return {
        activeTime: parseTimeSlug(getActiveTime(state), ownProps.timezone),
        barber: barberRoute && getBarberByIdOrRoute(state, barberRoute),
        duration: getServiceDuration(state, ownProps.params.serviceId),
      };
    },
    { clearBarberAvailability }
  ),
  withHandlers({
    reserveTime: props => (e, url) => {
      const barber = props.barber && props.barber.toJS();
      if (!barber || !props.activeTime) return;
      e.preventDefault();
      reserveTime(barber.id, props.activeTime.toJSON(), props.duration, props.kiosk)
        .then(() => props.router.push(url))
        .catch((err) => {
          props.clearBarberAvailability();
          props.fetchAvailability(
            getAvailableTimesStartDay(props.timezone)(props.activeTime),
            getAvailableTimesEndDay(props.timezone)(props.activeTime)
          );
          window.swal({
            title: 'Error!',
            text: err.message,
            type: 'error',
            confirmButtonColor: '#dd6b55',
          });
        });
    },
  })
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithReserveTimeHandler.js